import editLineItems from 'coact/editLineItems'

import ItemsEditorView from './ItemsEditor'

const ItemsEditor = editLineItems(ItemsEditorView)

ItemsEditor.displayName = 'ItemsEditor'

export default ItemsEditor



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/ItemsEditor/index.js